/**
 * Home page section copy.
 *
 * These strings used to be inline in Pages/Homepage.jsx, which is the one
 * thing the layout is not supposed to do: content belongs here so it can be
 * changed without opening a component.
 *
 * Voice note. The headings were "Crafting Solutions Architecture" and
 * "Showcasing My Work & Achievements". Everything else on the site is written
 * plainly, so those two stood out as brochure copy. A section heading should
 * say what is in the section.
 */

export const aboutSection = {
  eyebrow: "About",
  title: "Backend foundations, AI on top",
  subtitle:
    "The backend came first: Spring Boot microservices, database migrations and load testing in fintech. The AI work sits on top of that, not beside it.",
  backgroundTitle: "Background",
  cta: "More about me",
};

export const projectsSection = {
  eyebrow: "Projects",
  title: "Selected work",
  // The home page shows the three freelance projects only, so this line must
  // not promise the competition and academic work that sits behind the CTA.
  // It must also not claim all three have shipped: Serve is live, the other
  // two are in testing, and each project's summary says which.
  subtitle:
    "Three platforms built for businesses in Lebanon. One live, two in testing.",
  cta: "View all projects",
};
